<template>
  <div class="bannerBox">
    <div v-html="content"></div>
  </div>
</template>



<script>
export default {
  data() {
    return {
         id:'',
         content:''
    }
  },
  created(){
     this.id = this.$route.query.id
     this.getBannerDetail()
  },
  methods: {
   async getBannerDetail () {
   const res =   await  this.$get('/api/advertisement/info/' + this.id,{},4)
    if (res.data.code == 200) {
            this.content = res.data.advertisementinfo.intro;
            this.content = this.content.replace(/(\<img)/g, '<img style="width:100%;display:block;"');
          }
    },
  }
}
</script>



<style lang="less">
 .bannerBox{
   padding: 0 15px;
 }
</style>